var MaskTypeEnum;
(function (MaskTypeEnum) {
    MaskTypeEnum["Card"] = "card";
    MaskTypeEnum["AccountNumber"] = "account-number";
    MaskTypeEnum["Default"] = "default";
})(MaskTypeEnum || (MaskTypeEnum = {}));

export { MaskTypeEnum };
